<template>
  <section class="cn-category-cards-section">
    <div class="container">
      <div
        v-if="data?.items?.length"
        class="cn-category-cards-section__content"
      >
        <div
          v-for="(item, i) in data.items"
          :key="i"
          :class="classOfCard(item.size)"
        >
          <UiLink :to="item.link">
            <CategoryCard
              :image="item.image"
              :name="item.title"
              :models-count="item.subtitle"
              :color="item.variant"
              :small="item.size === 'small'"
              custom-models-count
            />
          </UiLink>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { Colors } from '@/composables/useBannersColors';
import CategoryCard from '@/components/CategoryCard';
import UiLink from '@/components/ui/UiLink';

interface Props {
  data: {
    items: {
      link: string;
      image?: string;
      title?: string;
      subtitle?: number | string;
      variant?: Colors;
      size?: 'small' | 'big';
    }[];
  };
}

defineProps<Props>();

const classOfCard = (size = 'big') => {
  return size !== 'small'
    ? 'col-span-4 sm:col-span-4 lg:col-span-2'
    : 'col-span-4 sm:col-span-2 lg:col-span-1';
};
</script>

<style lang="scss">
.cn-category-cards-section {
  padding: var(--size-3xl) 0;
  &__content {
    gap: var(--size-xl);
    grid-template-columns: repeat(4, minmax(0, 1fr));
    display: grid;
  }
}
</style>
